export default class PolingListener {
    isListening = false;
    intervalId = null;
    requester;
    dataProcessor;
    timeout;

    constructor(
        requester,
        dataProcessor,
        timeout = 30
    ) {
        this.requester = requester;
        this.dataProcessor = dataProcessor;
        this.timeout = timeout;
    }

    listen() {
        if (this.isListening) {
            return;
        }

        this.intervalId = setInterval(() => {
            (this.requester)().then(r => (this.dataProcessor)(r.data));
        }, 1000 * this.timeout);

        this.isListening = true;
    }

    stop() {
        if (this.isListening) {
            clearInterval(this.intervalId);
        }

        this.isListening = false;
    }

    refresh() {
        if (this.isListening) {
            (this.requester)().then(r => (this.dataProcessor)(r.data));
        }
    }
}
